import { hostnames } from 'features/common/config/envConfig';
import { history } from 'features/common/history/history';
import { getEnvironmentFromUrl } from 'features/context-ids/utils/environmentUtils';
import { RecommendationCard } from 'gql/graphql';

export const baseDeployUrl = {
  [hostnames.internal]: 'https://deploy-staging.sitecore-staging.cloud',
  [hostnames.localhost]: 'https://deploy-staging.sitecore-staging.cloud',
  [hostnames.dev]: 'https://deploy-dev.sitecore-staging.cloud',
  [hostnames.qa]: 'https://deploy-qa.sitecore-staging.cloud',
  [hostnames.staging]: 'https://deploy-staging.sitecore-staging.cloud',
  [hostnames.beta]: 'https://deploy-preprod.sitecorecloud.io',
  [hostnames['pre-production']]: 'https://deploy-preprod.sitecorecloud.io',
  [hostnames.production]: 'https://deploy.sitecorecloud.io',
};

export const baseXMCloudUrl = {
  [hostnames.internal]: 'https://app-staging.sitecore-staging.cloud',
  [hostnames.localhost]: 'https://app-staging.sitecore-staging.cloud',
  [hostnames.dev]: 'https://app-staging.sitecore-staging.cloud',
  [hostnames.qa]: 'https://app-staging.sitecore-staging.cloud',
  [hostnames.staging]: 'https://app-staging.sitecore-staging.cloud',
  [hostnames.beta]: 'https://app-preprod.sitecorecloud.io',
  [hostnames['pre-production']]: 'https://app-preprod.sitecorecloud.io',
  [hostnames.production]: 'https://app.sitecorecloud.io',
};

export const XmcCloudDeployCardId = 'XMCloudDeploy';
export const DEMO_SOLUTION_CARD_ID = 'DemoSolution';
export const XmCloudTrialCardId = 'XMCloudTrial';
export const InviteTeamMembersTrialCardId = 'InviteTeamMembersTrial';
export const GoLivePlanning = 'GoLivePlanning';

export const transformCardData = (
  cards: RecommendationCard[],
): RecommendationCard[] =>
  cards.map((card) =>
    card.cardId === XmcCloudDeployCardId
      ? {
          ...card,
          link: {
            type: card.link?.type ?? '',
            to: `${baseDeployUrl[window.location.hostname]}${
              history.location.search
            }`,
          },
        }
      : card,
  );

export const getDeployApiClickClickLaunchBaseUrl = (): string => {
  const env = getEnvironmentFromUrl();
  const stagingEnvs = ['dev', 'qa', 'staging'];
  const domainEnding = stagingEnvs.includes(env)
    ? 'sitecore-staging.cloud'
    : 'sitecorecloud.io';
  return `https://xmclouddeploy-api-${env}.${domainEnding}`;
};
